<template>
  <div class="application-info-bar">
    <v-icon color="primary" class="mr-2">
      mdi-text-box-outline
    </v-icon>
    <span class="font-weight-bold">{{ title }}</span>
    <span class="ml-1"> application </span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  name: "JobInfoBar"
};
</script>

<style lang="scss">
.application-info-bar {
  align-items: center;
  display: flex;
  justify-content: center;
  background-color: $background;
  width: 100%;
  height: 60px;
}
</style>
